import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
  OnChanges,
  ViewEncapsulation
} from '@angular/core';
import { Message } from 'src/app/models/message-model';
import { Subscription } from 'rxjs';
import { ChatService } from '../../../chat.service';
import { StarRatingModalComponent } from '../star-rating-modal/star-rating-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css', '../../../styling.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MessageComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  @Input() message: Message;
  @Input() lastMsg: Message;
  @Input() intentName: string;
  readMoreButton = false;
  @Input() showBotIcon: any;
  sessionAttributes: any;
  typingIndicator = true;
  @Output() suggestionMsgEv = new EventEmitter<any>();
  @Output() triggerRatingModuleEV = new EventEmitter<any>();
  isLastResponseNBI: boolean;
  showStarRatingModule: boolean;
  showYoutubeVideo = false;
  youtubeVideoPath;
  fileName: any;
  carouselData: Message;
  constructor(private chatService: ChatService, protected _sanitizer: DomSanitizer) {
    // this.subscription = this.chatService.typingIndicatorFn().subscribe(typing => {

    //   this.typingIndicator = typing
    // });
  }

  ngOnInit() {
    this.handleMessage();
  }

  handleMessage(): void {
    if (!this.message || !this.message.content) {
      return;
    }

    if (this.message.hasOwnProperty('content') && this.message.content === 'Thank you for chatting with us. Goodbye.') {
      // this.showStarRatingModule = true
      this.triggerRatingModule();
    } else {
      this.showStarRatingModule = false;
    }

    if (this.message?.content?.includes("attachment:")) {
      const parts = this.message.content.split(":");
      if (parts.length > 2 && parts[1]?.includes("tlce-attachments/")) {
        const splitFile = parts[1].split("tlce-attachments/");
        const fileName = splitFile.length > 1 ? splitFile[1] : null;
        const fileType = parts[2];
    
        if (fileName && fileType) {
          this.fileName = fileName;
        }
      }
    }
    
    const imgTagRegex = /<img\s+src="([^"]+)"\s+alt="([^"]*)"\s*\/?>/g;
    let match;
      
    this.message.imageList = [];
    
    while ((match = imgTagRegex.exec(this.message.content)) !== null) {
      const imageUrl = match[1];
      const altText = match[2] || imageUrl.split("/").pop();
    
      this.message.imageList.push({
        url: imageUrl, alt: altText,
        previewUrl: '',
        title: '',
        type: ''
      });
    }
    
    if (this.message.imageData?.length > 0) {
      const attachmentImages = this.message.imageData
        .filter(att => att.type === 'IMAGE' && att.url)
        .map(att => ({
          url: att.url,
          alt: att.title || att.url.split("/").pop(),
          preview: att.previewUrl || att.url
        }));
      
      this.message.imageList.push(...attachmentImages);
    }
    
    if (this.message.imageList.length === 1) {
      this.message.imageData = this.message.imageList[0].url;
    } else {
      this.message.imageData = null;
    }
    console.log("this.message.imageData=> ", this.message.imageData);
    
    //this.message.hasOwnProperty('content') ? ( this.message.content.length > 200 ? this.readMoreButton = true : null) : null;
    // if(this.message.content == 'NBI'){
    //     this.isLastResponseNBI = true
    // } else {
    //     this. isLastResponseNBI = false
    // }

    // if (this.intentName =="scheduleDemoWW"){
    //   this.message.content = this.message.content +"\n"+`<a href='' onclick="Calendly.initPopupWidget({url: 'https://calendly.com/thinglogix-demos/testing-ww-chatbot'});return false;\">Schedule a call for Demo</a>`
    // }

    if (this.message.content.indexOf('https://www.youtube.com/watch?') !== -1) {
      const url = this.message.content.split('https://www.youtube.com/watch?');
      const queryParams = url[1].split('"')[0];
      this.youtubeVideoPath = this._sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${queryParams.split('=')[1]}?autoplay=1&mute=1&rel=0 `);
      this.showYoutubeVideo = true;
    } else if (this.message.content.indexOf('https://youtu.be/') !== -1) {
      const url = this.message.content.split('https://youtu.be/');
      const queryParams = url[1].split('\"')[0];
      this.youtubeVideoPath = this._sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${queryParams}?autoplay=1&mute=1&rel=0 `);
      this.showYoutubeVideo = true;
    } else if (this.message.content.indexOf('https://www.youtube.com/embed/') !== -1) {
      const url = this.message.content.split('https://www.youtube.com/embed/');
      const id = url[1].split('"')[0];
      this.youtubeVideoPath = this._sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${id}?autoplay=1&mute=1&rel=0 `);
      this.showYoutubeVideo = true;
    } else {
      this.showYoutubeVideo = false;
      this.youtubeVideoPath = '';
    }


    if (this.showYoutubeVideo) {
      if (this.message.content.indexOf('Click here</a> to') !== -1) {
        this.message.content = this.message.content.replace('Click here', '');
      } else if (this.message.content.indexOf('click here</a> to') !== -1) {
        this.message.content = this.message.content.replace('click here', '');
      }
      this.message.content = this.message.content.replace('to see', 'see');
    }
  }

  isImage(): boolean {
    const isImage = ['.jpeg', '.jpg', '.png', '.gif'].some(ext => this.message.content.toLowerCase().includes(ext));
    return isImage;
  }
  
  isVideo(): boolean {
    const isVideoUrl = ['.mp4', '.webm'].some(ext => this.message.content.toLowerCase().includes(ext));
    return isVideoUrl;
  }
  
  isAudio(): boolean {
    const isAudioUrl = ['.mp3', '.wav', '.ogg'].some(ext => this.message.content.toLowerCase().includes(ext));
    return isAudioUrl;
  }
  
  isPdf(): boolean {
    const isPdfUrl = ['.pdf', '.csv', '.pptx'].some(ext => this.message.content.toLowerCase().includes(ext));
    return isPdfUrl; 
  }

  getFileType(url: string): string {
    const extension = url.split('.').pop()?.toLowerCase();
    if (!extension) return 'other';
    if (['jpg', 'jpeg', 'png', '.gif'].includes(extension)) return 'image';
    if (['mp4', 'webm'].includes(extension)) return 'video';
    if (['mp3', 'wav', 'ogg'].includes(extension)) return 'audio';
    if (extension === 'pdf') return 'pdf';
    if (extension === 'ppt' || extension === 'pptx') return 'pptx';
    return 'other';
  }


  openFile(url: string) {
    const type = this.getFileType(url);
    if (type === 'pptx') {
      const viewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
      window.open(viewerUrl, '_blank');
    } else {
      window.open(url, '_blank');
    }
  }

  triggerRatingModule() {
    this.triggerRatingModuleEV.emit();
    // this.showStarRatingModule = false
    // let element: HTMLElement = document.getElementById("starRating") as HTMLElement
    // element.click()
  }

  isAgentConnected() {
    return !!sessionStorage.getItem('agentSession');
  }

  sendMessage(msg, divId, slotToElicit) {
    console.log(" slotToElicit", slotToElicit);
    console.log("divId", divId);
    console.log("msg", msg);

    this.typingIndicator = true;
    const suggestionMsgDetails = {
      msg,
      divId,
      slotToElicit,
      sessionAttributes: this.sessionAttributes,
      clickedButton: null
    };
    this.suggestionMsgEv.emit(suggestionMsgDetails);
  }
  sendMessage1(msg, divId, slotToElicit, name, text, button) {
  console.log("227=> ", text);
  console.log("slotToElicit=> ", slotToElicit);
    this.sessionAttributes = {
      ...this.sessionAttributes,
      selectedOfferId: text
    };

  this.typingIndicator = true;
  const suggestionMsgDetails = {
      msg,
      divId,
      slotToElicit,
      sessionAttributes: this.sessionAttributes,
      clickedButton: button
    };
  // document.getElementById(divId).style.display = 'none';
  // if (document.getElementById('btn-1234567890')) {
  //     document.getElementById('btn-1234567890').style.display = 'none';
  //   }
  // document.getElementById(name).style.background = '#182F7C';
  // document.getElementById(text).style.color = '#ffffff';
  this.suggestionMsgEv.emit(suggestionMsgDetails);
  }
  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  openInNewWindow(content: string, title: string = 'New Window') {
    const win = window.open('', '_blank');
    if (win) {
      win.document.write(`<html><head><title>${title}</title></head><body>${content}</body></html>`);
    } else {
      console.error('Failed to open new window');
    }
  }

  openImageInNewWindow(imageData: string) {
    const image = `<img src="${imageData}" style="max-width: 90vw; max-height: 90vh; display: block; margin: auto;" />`;
    this.openInNewWindow(image, 'Image Viewer');
  }

  openAudioInNewWindow(audioUrl: string) {
    const audio = `<audio controls src="${audioUrl}"></audio>`;
    this.openInNewWindow(audio, 'Audio Playback');
  }

  openPdfInNewWindow(pdfUrl: string) {
    const iframe = `<iframe src="${pdfUrl}" width="100%" height="100%" style="border:none;"></iframe>`;
    this.openInNewWindow(iframe, 'PDF Viewer');
    
  } 
}
